import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { MultiSelectorComponent } from "@components/multi-selector/multi-selector.component";
import { Observable, of } from "rxjs";
import { IKeyValueGroup, ITplArbetsorder } from "../../../models/dtos";
import { TplService } from "../../../services/tpl.service";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-maskinlag-filter",
    templateUrl: "./tpl-maskinlag-filter.component.html",
    styleUrls: ["./tpl-maskinlag-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectorComponent
    ]
})
export class TplMaskinlagFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {
    items: Observable<IKeyValueGroup[]>;

    private readonly tplService = inject(TplService);

    constructor() {
        super("maskinlag");
    }

    isActive(): boolean {
        return this.value().length > 0;
    }

    match(item: ITplArbetsorder): boolean {
        return this.value().indexOf(item.maskinlagId) > -1;
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));

        this.items = of(this.tplService.allMaskinlag());
    }

    onFilterInit(state: number[]): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    value(): number[] {
        return this.control.value;
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        filterContext.addArbetsorderFilter(this.name, this);
    }

    protected onFormChange(value: number[]): void {
        this.filterLength = value.length;
    }
}
